module.exports = __webpack_public_path__ + "static/media/guarani-purahei-lopez-martin.a04ae882.jpg";